/**
 * City / state / ZIP line for SSAP summary (and optional county between city and state).
 */
export const formatSummaryAddressSecondLine = (
    city: string,
    state: string,
    postalCode: string,
    county: string | null | undefined,
): string => {
    const base = `${city}, ${state} ${postalCode}`;
    const countyStr =
        county != null && String(county).trim() !== '' ? String(county).trim() : '';
    if (countyStr) {
        return `${city}, ${countyStr}, ${state} ${postalCode}`;
    }
    return base;
};
